<template>
  <div ref="indicator" class="absolute z-90 opacity-0 elevated-button__indicator
    left-1/2 w-5 h-full rounded-full
    transform-origin-center pointer-events-none"
    :class="[colors[props.color]]">
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, watch } from 'vue'
import eventBus from '../eventbus.ts'
const props = withDefaults(defineProps<{
  color?: keyof typeof colors
  duration?: number
  id: string
}>(), {
  color: 'primary',
  duration: 250
})

const indicator = ref<HTMLElement | null>(null);

const emits = defineEmits<{
  (e: 'finished'): void
  (e: 'half-finished'): void
  (e: 'parent-click', event: MouseEvent): void
}>()

const colors = {
  "primary": "bg-apex-blue-800/30",
  "secondary": "bg-gray-600/10",
  "red": "bg-red-800/30",
}

const showIndicator = (e: any) => {
  if (!indicator.value || indicator.value == undefined) return;

  const parent = e.container
  const rect = parent.getBoundingClientRect();

  // set the center of the indicator to the click position
  let xOffset = 15;
  indicator.value.style.left = `-${xOffset}px`;
  indicator.value.style.top = '0px';

  // Center the indicator and scale it
  indicator.value.style.opacity = '1';
  indicator.value.style.width = `${rect.width + (xOffset * 2)}px`;
  indicator.value.style.height = `${rect.height}px`;


  setTimeout(() => {
    if (indicator.value != undefined) {
      indicator.value.style.opacity = '0';
      indicator.value.style.width = '0';
      indicator.value.style.left = rect.width / 2 + 'px';
      // indicator.value.style.transform = 'translate(-50%, -50%) scale(0)';
    }

    emits('finished');
  }, props.duration);

  setTimeout(() => {
    emits('half-finished');
  }, props.duration / 2);
}

onMounted(() => {
  // set --duration css variable
  indicator.value?.style.setProperty('--duration', `${props.duration}ms`);
  watch(() => eventBus[props.id], (e: any) => {
    if (e) {
      showIndicator(e);
    }
  })
})
</script>

<style scoped>
:root {
  --duration: 0.5s;
}

.elevated-button__indicator {
  transition: opacity var(--duration), transform var(--duration), left var(--duration), top var(--duration), width var(--duration), height var(--duration);
}
</style>